export default __webpack_public_path__ + "static/media/972.5cd4bf6d.png";